import * as Constants from '@/lib/constants'
import store from '@/store'

const FIELD_PAGING_TYPE = 'field'
const TASK_PAGING_TYPE = 'task'
const REF_LINE_PAGING_TYPE = 'refLine'

export default class PagingOptions {
  static get FIELD_PAGING_TYPE() {
    return FIELD_PAGING_TYPE
  }
  static get TASK_PAGING_TYPE() {
    return TASK_PAGING_TYPE
  }
  static get REF_LINE_PAGING_TYPE() {
    return REF_LINE_PAGING_TYPE
  }
  static getPagingOptions(pagingType) {
    let pageSize
    let pageIndex
    if (pagingType === FIELD_PAGING_TYPE) {
      pageSize = store.getters.pagingOptions.fields.pageSize
      pageIndex = store.getters.pagingOptions.fields.page
    } else if (pagingType === TASK_PAGING_TYPE) {
      pageSize = store.getters.pagingOptions.tasks.pageSize
      pageIndex = store.getters.pagingOptions.tasks.page
    } else if (pagingType === REF_LINE_PAGING_TYPE) {
      pageSize = store.getters.pagingOptions.refLines.pageSize
      pageIndex = store.getters.pagingOptions.refLines.page
    } else {
      console.error('Missing paging type. @pagingType=' + pagingType)
      pageSize = Constants.DEFAULT_LIST_PAGE_SIZE
      pageIndex = 0
    }
    return { pageSize: pageSize, pageIndex: pageIndex }
  }
}
